<template>
  <PaymentHistoryComponent />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PaymentHistoryComponent from "@/components/payment/PaymentHistory.vue";

const componentName = "PaymentHistoryRoute";

export default defineComponent({
  name: componentName,
  components: { PaymentHistoryComponent },
});
</script>
